export const employeeReviews = [
  {
    id: 1,
    name: "Анна К.",
    experience: "2 года в компании",
    rating: 5,
    text: "Работаю удаленно уже второй год, график гибкий, выплаты всегда вовремя. Поддержка со стороны руководства на высшем уровне. Рекомендую всем, кто хочет стабильный доход без привязки к офису.",
    avatar: "/readdy/06f17e2b6301c4bd7c12bd576e1b5e12.jpeg",
  },
  {
    id: 2,
    name: "Дмитрий С.",
    experience: "1.5 года в компании",
    rating: 5,
    text: "Отличная компания для старта в гостиничной сфере. Обучение CRM Битрикс24 прошло быстро, сейчас обрабатываю бронирования крупных отелей. Оплата еженедельная — очень удобно.",
    avatar: "/readdy/1eff99b18df56c14b30af364c5e718db.jpeg",
  },
  {
    id: 3,
    name: "Елена М.",
    experience: "3 года в компании",
    rating: 4,
    text: "График 2/2 позволяет совмещать работу с учебой. Иногда ночные смены утомляют, но почасовая оплата компенсирует. Хорошая команда, всегда можно рассчитывать на помощь коллег.",
    avatar: "/readdy/fa5b4a7f6af9c42704f96d457b6d5fe0.jpeg",
  },
  {
    id: 4,
    name: "Игорь В.",
    experience: "8 месяцев в компании",
    rating: 5,
    text: "Попал сюда через знакомых и не пожалел. Договор ГПХ оформили за день, начал работать на следующий. CRM система интуитивно понятная, обучение заняло пару часов. Зарабатываю больше, чем на прошлой работе.",
    avatar: "/readdy/2577c038a1e9874513751ee98588e78f.jpeg",
  },
  {
    id: 5,
    name: "Мария П.",
    experience: "1 год в компании",
    rating: 3,
    text: "Работа неплохая, но иногда бывают накладки с графиком. В целом для удаленной работы вариант хороший — не нужно никуда ездить, сидишь дома и обрабатываешь заявки. Оплата стабильная.",
    avatar: "/readdy/2f5f26637d8aad4ff566376848717560.jpeg",
  },
];